import { useParams } from 'react-router-dom';
import { Button, CircularProgress, makeStyles } from '@material-ui/core';
import axios from 'api/axios';
import { useSearchParams } from 'hooks/useSearchParams';
import { localText } from 'langs/fa/data-grid';
import React, { useEffect, useReducer, useRef, useState } from 'react';
import { useQuery } from 'react-query';
import { useMainStore } from 'useStores/useMainStore';
import DataGrid from 'components/DataGrid/DataGrid';
import { useHistory, useLocation } from 'react-router-dom';
import { __ } from 'utils/i18n';
import moment from 'moment-jalaali';
import { formatNumber } from 'fns';
import { toFA } from 'fns/toFA';
import useTitle from 'hooks/useTitle';
import { initialState, reducer } from './reducer';
import { useFreight } from 'useStores/useFreight';
import CallsListModal from './CallingList/CallsListModal';
import ListOfBidders from './OffersList/ListOfBidders';
import ReportsListModal from './ReportsList/ReportsListModal';
import ReportsButton from './ReportsList/ReportsButton';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    height: 480,
    '& .pending': {
      background: '#ffecb3',
    },
    '& .tendering': {
      background: '#e6ee9c',
    },
    '& .getWaybill': {
      background: '#bbdefb',
    },
    '& .rejected': {
      background: '#e0e0e0',
    },
    '& .loadTime': {
      fontSize: 12,
    },
    '& .colHeader': {
      background: '#607d8b',
      color: '#fff',
    },
  },
  fleetCount: {
    '& > span.red': {
      background: '#dd2c00',
      color: '#fff',
      padding: theme.spacing(1),
      marginRight: theme.spacing(1),
    },
    '& > span.green': {
      background: '#76ff03',
      padding: theme.spacing(1),
    },
  },
  allOrders: {
    position: 'absolute',
    bottom: 15,
    left: 150,
  },
}));

const OffersButton = ({ openOffersModal, orderId }) => {
  const fetchOffers = async () => {
    const { data } = await axios.get(
      `/api/v1/admin/freight/order/${orderId}/bids`
    );
    return data;
  };

  const { data, isLoading, refetch } = useQuery(
    ['offersList', orderId],
    () => fetchOffers(),
    { refetchOnWindowFocus: false }
  );

  return (
    <Button
      onClick={openOffersModal}
      disabled={isLoading}
      endIcon={isLoading && <CircularProgress size={10} />}
      className=""
      variant="contained"
      color="secondary"
      size="small"
    >
      {data?.bids ? `پیشنهادات: ${toFA(data?.bids.length)}` : 'پیشنهادات'}
    </Button>
  );
};

const FreightOrdersList = () => {
  useTitle('سفارشات باربری');
  const [addTitle] = useTitle('سفارشات باربری');
  const { freightId } = useParams();
  const classes = useStyles();
  const limit = useMainStore((state) => state.limit);
  const [params, setParams, deleteParams] = useSearchParams();
  const page = params.get('page');
  const [totalPages, setTotalPages] = useState(null);
  const history = useHistory();
  const location = useLocation();
  const setTitle = useFreight((state) => state.setTitle);
  const setCategory = useFreight((state) => state.setCategory);
  const setReportsOrderIds = useFreight((state) => state.setReportsOrderIds);
  const reportOrderIds = useFreight((state) => state.reportOrderIds);
  const [orderId, setOrderId] = useState(null);

  async function fetchReports(ids) {
    try {
      for await (const id of ids) {
        const {
          data: {
            resultOfDriversCalls: { totalDocs },
          },
        } = await axios.get(
          `/api/v1/admin/freight/order/${id}/resultOfDriversCalls?offset=0&limit=1`
        );
        setReportsOrderIds(id, totalDocs);
      }
    } catch (error) {}
  }

  const columns = [
    {
      field: 'loadingDate',
      headerName: 'بارگیری',
      renderCell: ({ value }) => <>{value}</>,
      width: 130,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
    {
      field: 'origin',
      headerName: 'مبدا',
      flex: 1,
      renderCell: ({ value }) => <>{value}</>,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
    {
      field: 'fleet',
      headerName: 'ناوگان',
      width: 180,
      renderCell: ({ value }) => <>{value}</>,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 110,
      renderCell: ({ value }) => <>{value}</>,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
    {
      field: 'cargo',
      headerName: 'محموله',
      width: 140,
      renderCell: ({ value }) => <>{value}</>,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
    {
      field: 'count',
      headerName: 'تعداد',
      width: 110,
      renderCell: ({ value }) => <>{value}</>,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
    {
      field: 'price',
      headerName: 'کرایه حمل',
      width: 140,
      renderCell: ({ value }) => <>{value}</>,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 130,
      renderCell: ({ value }) => <>{value}</>,
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
    {
      field: 'actions',
      headerName: ' ',
      width: 280,
      renderCell: ({ value }) => {
        const res = reportOrderIds.find(
          (report) => report.id === value?.orderId
        );
        return (
          <>
            <Button
              onClick={() => openCallsModal(value?.orderId)}
              className="ms-1"
              variant="contained"
              color="primary"
              size="small"
            >{`تماس ها: ${toFA(value.calls)}`}</Button>
            {/* <OffersButton
            openOffersModal={() => openOffersModal(value?.orderId)}
            orderId={value?.orderId}
          /> */}
            {/* <ReportsButton
            openReportsModal={() => openReportsModal(value?.orderId)}
            orderId={value?.orderId}
          /> */}
            <Button
              onClick={() => openReportsModal(res.id)}
              // disabled={loading}
              // endIcon={loading && <CircularProgress size={10} />}
              className="me-1"
              variant="outlined"
              color="primary"
              size="small"
            >
              {res?.totalDocs !== undefined
                ? `گزارشات: ${res?.totalDocs}`
                : 'صبرکنید...'}
            </Button>
          </>
        );
      },
      // cellClassName: ({ value: { status } }) => status,
      // headerClassName: 'colHeader',
    },
  ];

  function handlePageChange(page) {
    setParams([{ name: 'page', value: page }]);
  }
  const closeCallsListModal = () => {
    deleteParams([{ name: 'callsModal' }, { name: 'orderId' }]);
  };
  const closeOffersListModal = () => {
    deleteParams([{ name: 'offersModal' }, { name: 'orderId' }]);
  };
  const closeReportsListModal = () => {
    deleteParams([{ name: 'reportsModal' }, { name: 'orderId' }]);
  };
  const openCallsModal = (id) => {
    setParams([
      { name: 'callsModal', value: true },
      { name: 'orderId', value: id },
    ]);
  };
  const openOffersModal = (id) => {
    setParams([
      { name: 'offersModal', value: true },
      { name: 'orderId', value: id },
    ]);
  };
  const openReportsModal = (id) => {
    setParams([{ name: 'reportsModal', value: true }]);
    setParams([{ name: 'orderId', value: id }]);
  };

  function handleOrders(status, array) {
    const item = array.find((item) => item.status === status);
    return item;
  }

  const fetchFreightOrders = async () => {
    const { data } = await axios.get(
      `/api/v1/admin/freight/orders/list/byFreight/${freightId}?page=${
        params.get('page') || 1
      }&limit=${limit}`
    );
    data.totalPages && setTotalPages(data.totalPages);
    return data;
  };

  const { data, isLoading } = useQuery(
    ['freightOrders', params.get('page'), limit],
    () => fetchFreightOrders(),
    { refetchOnWindowFocus: false }
  );

  const ids = data?.docs?.map((item) => item._id) || [];

  const handleSelectOrder = (data) => {
    if (data.field !== 'actions') {
      history.push({
        pathname: `/protected/admin/freights/editFreightOrder/${data.row.id}`,
        state: freightId,
      });
    } else {
      setOrderId(data.row.id);
    }
  };

  React.useEffect(() => {
    setTitle('لیست سفارشات باربری ');
    setCategory('نمایش کلیه سفارشات باربری ');
  }, [location.pathname]);

  useEffect(() => {
    fetchReports(ids);
  }, [page, limit, ids.length]);

  useEffect(() => {}, [reportOrderIds]);

  return (
    <div className={classes.root}>
      {params.get('callsModal') && (
        <CallsListModal
          open={params.get('callsModal') === 'true'}
          onClose={closeCallsListModal}
          id={params.get('orderId')}
        />
      )}
      {params.get('offersModal') && (
        <ListOfBidders
          open={params.get('offersModal') === 'true'}
          handleClose={closeOffersListModal}
          id={params.get('orderId')}
        />
      )}
      {params.get('reportsModal') && (
        <ReportsListModal
          open={params.get('reportsModal') === 'true'}
          onClose={closeReportsListModal}
          id={params.get('orderId')}
        />
      )}
      <DataGrid
        rows={
          data?.docs?.map((freight) => ({
            id: freight?._id,
            loadingDate: moment(freight.createdAt).format('jYYYY/jMM/jDD'),
            origin: `${freight.origin?.city?.title}`,
            fleet:
              freight?.fleetOptions.length >= 3
                ? freight?.fleetOptions.map((item, i) => (
                    <div>
                      {`${item?.title || '-'} ${
                        i < freight?.fleetOptions.length - 1 ? '-' : ''
                      }`}
                    </div>
                  ))
                : freight?.fleetOptions.map((item, i) => (
                    <div>
                      {`${item?.fleet?.title} ${item?.title || '-'}  ${
                        i < freight?.fleetOptions.length - 1 ? '-' : ''
                      }`}
                    </div>
                  )),
            cargo: freight.cargoType?.title,
            destination: `${freight.destination?.city?.title}`,
            count: freight.fleetCount,
            price: freight.basePrice
              ? toFA(formatNumber(freight.basePrice))
              : 'توافقی',
            status: __(freight.status),
            actions: { calls: freight.numberOfCalled, orderId: freight._id },
          })) || []
        }
        columns={columns}
        localeText={localText}
        pageSize={Number(limit)}
        rowCount={data?.totalDocs || 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={isLoading}
        disableMultipleSelection
        onCellClick={handleSelectOrder}
        // onSelectionModelChange={handleSelectOrder}
        density="compact"
        // onSelectionChange={handleSelectOrder}
        disableSelectionOnClick
        // components={{
        //   NoRowsOverlay: NoDrivers,
        // }}
        pageNumber={params.get('page') ? Number(params.get('page')) : 1}
        // checkboxSelection={true}
        // hasSelectAll
        footerPagination={true}
        totalPages={totalPages}
        defaultPage={params.get('page') * 1 || 1}
        // onCellClick={handleSelectFreight}
      />
    </div>
  );
};

export default FreightOrdersList;
